import type { FunctionComponent } from 'react'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { useResubscribeBannerPersonalisationInfoQuery } from '../../../generated/frontend'
import { Loader } from '../Loader'
import { BannerNoOffer } from './components/BannerNoOffer/BannerNoOffer'
import { WinbackOfferBanner } from './components/WinbackOfferBanner/WinbackOfferBanner'

const BannerExperiment: FunctionComponent = () => {
  const showWinbackOffer = useFeatureIsOn('DSP-017-Winback-banner-offer')

  return showWinbackOffer ? <WinbackOfferBanner /> : <BannerNoOffer />
}

type ResubscribeBannerProps = {
  showBanner?: boolean
}

export const ResubscribeBanner: FunctionComponent<ResubscribeBannerProps> = ({ showBanner }) => {
  const { loading, data } = useResubscribeBannerPersonalisationInfoQuery({
    skip: showBanner !== true,
  })

  if (loading) {
    return <Loader />
  }

  const { enableWinbackOffer } = data?.personalisationInfo ?? {}

  if (showBanner === true) {
    if (enableWinbackOffer) {
      return <BannerExperiment />
    }

    return <BannerNoOffer />
  }

  return null
}
